/**
 * Updates the "Technische Daten" and "Downloads" product blocks when the
 * selected variant changes, since their content depends on
 * `product.selected_or_first_available_variant` metafields. These blocks
 * live in the "product-description" section, which isn't part of the HTML
 * the variant picker itself re-fetches, so they're re-fetched independently.
 */
webvista.subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const variant = event.data.variant;
  if (!variant) return;

  const anchor = document.querySelector('[id^="ProductAttributes-"]');
  if (!anchor) return;

  const sectionId = anchor.id.replace("ProductAttributes-", "");
  const productUrl = anchor.dataset.productUrl;

  webvista
    .fetchHtml(`${productUrl}?variant=${variant.id}&section_id=${sectionId}`)
    .then((html) => {
      ["ProductAttributes", "ProductDocuments"].forEach((blockId) => {
        const targetElement = document.getElementById(
          `${blockId}-${sectionId}`,
        );
        const sourceElement = html.getElementById(`${blockId}-${sectionId}`);
        if (!targetElement || !sourceElement) return;

        targetElement.innerHTML = sourceElement.innerHTML;
      });
    })
    .catch(() => {});
});

/**
 * Updates the delivery estimate block on variant change. Unlike the blocks
 * above, this one lives in the same ("main") section the variant picker
 * already re-fetches, so it reuses that HTML instead of fetching again.
 */
webvista.subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const sectionId = event.data.sectionId;
  const html = event.data.html;
  if (sectionId == null || html == null) return;

  const targetElement = document.getElementById(`Delivery-${sectionId}`);
  const sourceElement = html.getElementById(`Delivery-${sectionId}`);
  if (!targetElement || !sourceElement) return;

  targetElement.outerHTML = sourceElement.outerHTML;
});
